import { _ as _slicedToArray } from './slicedToArray-a6a95674.js';
import { useMemo, useState, useEffect } from 'react';
import getTimeUntil from './getTimeUntil/index.js';
import { AbsolutesBlackColors, AbsolutesWhiteColors, BackgroundColors, SecondaryColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { createUseStyles } from 'react-jss';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { jsxs, jsx } from 'react/jsx-runtime';

var typeStyles = {
  black: {
    background: AbsolutesBlackColors.base["default"],
    fontColor: AbsolutesWhiteColors.base["default"],
    separatorColor: AbsolutesBlackColors.base["default"]
  },
  light: {
    background: BackgroundColors.tint3,
    fontColor: SecondaryColors.base["default"],
    separatorColor: SecondaryColors.base["default"]
  },
  white: {
    background: AbsolutesWhiteColors.base["default"],
    fontColor: AbsolutesBlackColors.base["default"],
    separatorColor: AbsolutesWhiteColors.base["default"]
  }
};
var useStyles = createUseStyles({
  '@keyframes blink': {
    '0%': {
      opacity: 1
    },
    '50%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },
  root: {
    fontWeight: FontWeights.bold,
    fontSize: function fontSize(_ref) {
      var size = _ref.size;
      return size === 'large' ? FontSizes.s20 : FontSizes.s14;
    },
    alignItems: 'center',
    display: 'flex',
    gap: 4
  },
  timeNumber: {
    color: function color(_ref2) {
      var skin = _ref2.skin;
      return typeStyles[skin].fontColor;
    },
    background: function background(_ref3) {
      var skin = _ref3.skin;
      return typeStyles[skin].background;
    },
    padding: function padding(_ref4) {
      var size = _ref4.size;
      return size === 'large' ? 8 : 4;
    },
    borderRadius: CornerRadius.r8
  },
  separator: {
    color: function color(_ref5) {
      var skin = _ref5.skin;
      return typeStyles[skin].separatorColor;
    },
    animationIterationCount: 'infinite',
    animationDuration: '1s',
    animationName: '$blink'
  }
}, {
  name: 'pa-monetization-timer'
});

var Timer = function Timer(_ref) {
  var endDate = _ref.endDate,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    skin = _ref.skin;
  var timerSkin = useMemo(function () {
    if (skin) return skin;
    if (size === 'large') return 'light';
    return 'white';
  }, [skin, size]);
  var classes = useStyles({
    skin: timerSkin,
    size: size
  });
  var _useState = useState(function () {
      return getTimeUntil(endDate);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    timeUntil = _useState2[0],
    setTimeUntil = _useState2[1];
  useEffect(function () {
    // set interval and update time after a minute
    setInterval(function () {
      setTimeUntil(getTimeUntil(endDate));
    }, 60000);
  }, [endDate]);
  if (!timeUntil) return null;
  var days = timeUntil.days,
    hours = timeUntil.hours,
    minutes = timeUntil.minutes;
  return /*#__PURE__*/jsxs("div", {
    className: classes.root,
    children: [/*#__PURE__*/jsxs("span", {
      className: classes.timeNumber,
      children: [days, "d"]
    }), /*#__PURE__*/jsx("span", {
      className: classes.separator,
      children: ":"
    }), /*#__PURE__*/jsxs("span", {
      className: classes.timeNumber,
      children: [hours, "h"]
    }), /*#__PURE__*/jsx("span", {
      className: classes.separator,
      children: ":"
    }), /*#__PURE__*/jsxs("span", {
      className: classes.timeNumber,
      children: [minutes, "m"]
    })]
  });
};

export { Timer as T };
//# sourceMappingURL=Timer-4fc9e29c.js.map
